export const en = {
  nav: {
    listings: "Listings",
    map: "Map",
    favorites: "Favorites",
    messages: "Messages",
    publish: "Publish",
    login: "Sign in",
    register: "Sign up",
    dashboard: "Dashboard",
    logout: "Sign out",
    tagline: "Borderless",
    subtitle: "Maghreb Real Estate",
  },
  home: {
    badge: "Borderless · Maghreb",
    title_part1: "The largest",
    title_part2: "real estate market",
    title_part3: "in the",
    title_highlight: "Maghreb",
    description: "Verified listings from private sellers and pro agencies across Morocco, Algeria and Tunisia. Powerful search, interactive map, and direct contact.",
    cta_browse: "Browse listings",
    cta_publish: "Publish a listing",
    stat_listings: "Active listings",
    stat_advertisers: "Advertisers",
    stat_verified: "Verified pros",
    stat_countries: "Maghreb",
    featured_overline: "Selection",
    featured_title: "Featured listings",
    country_all: "All",
    view_all: "View all listings",
    pros_overline: "For agencies",
    pros_title: "Boost your visibility to thousands of buyers.",
    pros_desc: "\"Verified Pro\" badge, listing boosts, detailed statistics, centralized management. The platform built for Maghreb real estate professionals.",
    pros_cta: "Create a Pro account",
  },
  search: {
    overline: "Search",
    title: "Property listings",
    placeholder_country: "Country",
    placeholder_type: "Sale / Rent",
    placeholder_property_type: "Property type",
    placeholder_city: "City",
    placeholder_min_price: "Min price",
    placeholder_max_price: "Max price",
    placeholder_keyword: "Keyword (e.g. pool, sea view...)",
    placeholder_rooms: "Min rooms",
    button_reset: "Reset",
    button_search: "Search",
    grid: "Grid",
    map: "Map",
    results_count_one: "{{count}} listing found",
    results_count_other: "{{count}} listings found",
    no_results: "No listings match your filters.",
    countries: { all_long: "All countries", all_short: "All", MA: "Morocco", DZ: "Algeria", TN: "Tunisia" },
    types: { all: "Sale & Rent", vente: "Sale", location: "Rent" },
  },
  detail: {
    back: "Back to results",
    description: "Description",
    amenities: "Amenities",
    location: "Location",
    send_message: "Send message",
    sending: "Sending...",
    add_to_favorites: "Add to favorites",
    in_favorites: "In your favorites",
    badge_verified: "Verified listing",
    verified_text: "All our Pro advertisers are manually verified to guarantee safe transactions.",
  },
  auth: {
    login_title: "Welcome back",
    login_subtitle: "Access your 3aqarate dashboard.",
    register_title: "Join 3aqarate",
    register_subtitle: "Publish your listings in minutes.",
    email: "Email",
    password: "Password",
    name: "Full name",
    role: "Account type",
    role_particulier: "Individual",
    role_pro: "Pro / Agency",
    company: "Agency name",
    country: "Country",
    submit_login: "Sign in",
    submit_register: "Create my account",
    or: "or",
    google_continue: "Continue with Google",
    google_signup: "Sign up with Google",
    no_account: "No account yet?",
    yes_account: "Already a member?",
    create: "Sign up",
  },
  dashboard: {
    overline: "Dashboard",
    greeting: "Hello, {{name}}",
    pro: "Verified pro",
    particulier: "Individual account",
    new_listing: "New listing",
    stats_total: "Listings",
    stats_active: "Active",
    stats_boosted: "Boosted",
    stats_favorites: "Favorites",
    stats_messages: "Messages",
    stats_views: "Views",
    stats_views_week: "(7d)",
    my_listings: "My listings",
    no_listings: "You don't have any listing yet.",
    create_first: "Create my first listing",
    boost: "Boost",
    edit: "Edit",
    delete: "Delete",
    boosted_label: "Boosted",
    confirm_delete_title: "Delete this listing?",
    confirm_delete_desc: "This is permanent. The listing will be removed from the site.",
    cancel: "Cancel",
    become_pro_title: "Become a verified Pro",
    become_pro_desc: "Verified badge, unlimited listings and monthly boost included.",
    become_pro_btn: "Go Pro",
    recommendation_low_views: "Few views — a boost would significantly help",
    recommendation_low_conversion: "Many views but few contacts — boost or improve photos",
    views_label: "Views",
    messages_label: "Contacts",
    conversion_label: "Conv.",
  },
  favorites: {
    overline: "Favorites",
    title: "Your saved properties",
    empty: "You don't have any favorite yet.",
  },
  messages: {
    overline: "Messages",
    title: "Your conversations",
    empty: "No conversation yet.",
    select_thread: "Select a conversation on the left",
    with: "With",
    reply_placeholder: "Your reply...",
  },
  language: {
    fr: "Français",
    ar: "العربية",
    en: "English",
  },
};
